import React, { useState } from 'react';
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { BodyLarge, BodyRegular } from '@shared/ui/atoms/fonts/Body';
import Colours from '@shared/ui/atoms/Colours';
import { UpdateUserField, updateUserField } from '@features/settings/services/UserService';
import { Row } from '@shared/ui/atoms/StructuralLayout';
import { SpaceBetweenRow } from "../StyleComponents";
import { Switch } from '@shared/ui/atoms/Switch';

const MONTHS: {label: string, id: number}[] = [{label: 'January', id: 1}, {label: 'February', id: 2}, {label: 'March', id: 3}, {label: 'April', id: 4}, {label: 'May', id: 5}, {label: 'June', id: 6}, {label: 'July', id: 7}, {label: 'August', id: 8}, {label: 'September', id: 9}, {label: 'October', id: 10}, {label: 'November', id: 11}, {label: 'December', id: 12}]
function daysInRange(count: number): number[] {
  return Array.from({length: count}, (_, i) => i + 1);
}

function DAYS(monthLabel: number): number[] {
  // Coerce: the native <select> onChange gives string values, so month may be a string.
  const month = Number(monthLabel);
  if ([1,3,5,7,8,10,12].includes(month)) {
    return daysInRange(31)
  } else if ([4,6,9,11].includes(month)) {
    return daysInRange(30)
  } else if (month === 2) {
    return daysInRange(29)
  } else {
    return [];
  }
}

export function BirthdaySection(props: Props) {
  const {t} = useTranslation();
  const {userId} = props;
  const [dayLoading, setDayLoading] = useState(false);
  const [monthLoading, setMonthLoading] = useState(false);
  const [day, setDay] = useState(props?.birthdayDay ?? 0);
  const [month, setMonth] = useState(props?.birthdayMonth ?? 0);
  const [enabled, setEnabled] = useState(!!props.birthdayMonth && !!props.birthdayDay);

  const onDaySelect = async (day: any) => {
    try {
      if (userId) {
        setDayLoading(true)
        await updateUserField(userId, UpdateUserField.birthdayDay, day);
        setDay(day);
      }
    } finally {
      setDayLoading(false);
    }
  }

  const onMonthSelect = async (month: any) => {
    try {
      if (userId) {
        setMonthLoading(true)
        await updateUserField(userId, UpdateUserField.birthdayMonth, month);
        setMonth(month);
      }
    } finally {
      setMonthLoading(false);
    }
  }

  const onSwitchToggled = async (value: boolean) => {
    try {
      if (!value && userId) {
        setMonthLoading(true)
        setDayLoading(true)
        await updateUserField(userId, UpdateUserField.birthdayMonth, 0);
        await updateUserField(userId, UpdateUserField.birthdayDay, 0);
        setMonth(0);
        setDay(0);
      }
      setEnabled(value);
    } finally {
      setMonthLoading(false);
      setDayLoading(false);
    }
  }

  return (
    <Wrapper>
      <SpaceBetweenRow>
        <BodyLarge colour={Colours.blue}>{t('settings-page.edit-user.birthday.title')}</BodyLarge>
        <Switch value={enabled} onChange={onSwitchToggled} />
      </SpaceBetweenRow>

      <BodyRegular style={{marginBottom: 24}}>{t('settings-page.edit-user.birthday.description')}</BodyRegular>

      {enabled && <DropDownRow>
        <Column>
          <BodyRegular weight={600}>{t('settings-page.edit-user.birthday.month')}</BodyRegular>
          <select className={'teamDropDownList dropDownList'} disabled={monthLoading} value={month} onChange={(e) => onMonthSelect(Number(e.target.value))}>
            <option disabled={true} value={0}> -- Month --</option>
            {MONTHS.map((item: any, k) => <option key={k} value={item.id}>{item.label}</option>)}
          </select>
        </Column>

        <Column>
          <BodyRegular weight={600}>{t('settings-page.edit-user.birthday.day')}</BodyRegular>
          <select className={'teamDropDownList dropDownList'} disabled={dayLoading} value={day} onChange={(e) => onDaySelect(Number(e.target.value))}>
            <option disabled={true} value={0}> -- Day --</option>
            {DAYS(month).map((item: number, k) => <option key={k} value={item}>{item}</option>)}
          </select>
        </Column>
      </DropDownRow>}

    </Wrapper>
  )
}

interface Props {
  birthdayMonth?: number;
  birthdayDay?: number;
  userId?: string;
}

const Wrapper = styled.div`
  .teamDropDownList {
    width: 100%;
  }
  border-bottom: 1px solid ${Colours.mildGrey};
  margin-bottom: 24px;
  padding-bottom: 12px;
`

const DropDownRow = styled(Row)`
  gap: 16px;
`

const Column = styled.div`
  flex: 1;
  min-width: 0;
`
